const Banner = ({
  mode = 'info',
  title,
  message,
  className,
}: {
  mode?: 'info' | 'warning' | 'error';
  title: string;
  message: string;
  className?: string;
}) => {
  return (
    <div
      className={`text-black p-4 border-[1px] rounded-lg ${
        mode === 'info'
          ? 'bg-primary-200 border-primary-500'
          : mode === 'warning'
          ? 'bg-yellow-200 border-2 border-yellow-500'
          : 'bg-red-200 border-2 border-yellow-500'
      } ${className}`}
    >
      {title && <h5>{title}</h5>}
      {message && <p>{message}</p>}
    </div>
  );
};

export default Banner;
